




















































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {AxiosStatic} from "axios";
import { BPopover } from 'bootstrap-vue';


@Component({
	components: {BPopover},
})
export default class CreateCustomfieldModal extends Vue {

	@Prop({
		required: true,
		type: Number
	})
	public resourceid!: number;

	public newName: string = '';
	public newHelp: string = '';
	public newPlaceholder: string = '';
	public newType: string = 'text';
	public newRequired: number = 0;
	public newInternal: number = 0;
	public newShowInList: number = 0;
	public newShowInDetails: number = 0;
	public newSelectValues: string[] = [''];

	public showError: boolean = false;
	public isLoading: boolean = false;

	public $refs!: {
		createCustomfieldModal: any
	};

	private $http!: AxiosStatic;

	public mounted() {
		this.$root.$on('bv::modal::hidden', (bvEvent: any, modalId: string) => {
			if (modalId === 'createCustomfieldModal') {
				this.newName = '';
				this.newHelp = '';
				this.newPlaceholder = '';
				this.newType = 'text';
				this.newRequired = 0;
				this.newInternal = 0;
				this.newShowInList = 0;
				this.newShowInDetails = 0;
				this.newSelectValues = [''];
				this.showError = false;
				this.isLoading = false;
			}
		})
	}

	public open() {
		this.$refs['createCustomfieldModal'].show()
	}

	public close() {
		this.$refs['createCustomfieldModal'].hide()
	}

	public addOption() {
		this.newSelectValues.push('');
	}

	public removeOption(index: number) {
		this.newSelectValues.splice(index, 1);
	}

	public createCustomfield() {
		if (this.newName.length > 0) {
			this.isLoading = true;
			this.showError = false;
			let nonEmptyValues = this.newSelectValues.filter(val => val.length > 0);
			let data = {
				name: this.newName,
				help: this.newHelp,
				placeholder: this.newPlaceholder,
				type: this.newType,
				required: this.newRequired,
				internal: this.newInternal,
				show_in_list: this.newShowInList,
				show_in_details: this.newShowInDetails,
				select_values: JSON.stringify(nonEmptyValues),
			};
			this.$http.post('/private/resource/' + this.resourceid + '/customfield', data).then(() => {
				this.$store.dispatch('loadResources', {root: true});
				this.isLoading = false;
				this.close();
			}).catch(() => {
				this.isLoading = false;
				this.showError = true;
			});
		}
	}

}
